module.exports = __webpack_public_path__ + "img/hannou2.955a69e6.png";